$results-container-bg-color: white;
$results-container-padding: 0.5rem 1rem;
$results-container-margin: 0.5rem 0;

.resultsContainer {
    background-color: $results-container-bg-color;
    padding: $results-container-padding;
    margin: $results-container-margin;
}

.resultsTitle {
    margin: 0;
    font-size: 1rem;
    font-weight: bold;
}

$results-table-width: 100%;
$results-table-border-collapse: collapse;
$results-table-font-size: 0.875rem;
$results-table-padding: 0.25rem;

.resultsTable {
    width: $results-table-width;
    border-collapse: $results-table-border-collapse;
    font-size: $results-table-font-size;

th {
    text-align: left;
    padding: $results-table-padding;

&:last-child {
     text-align: right;
 }
}

td {
    text-align: left;
    padding: $results-table-padding;
    border-bottom: 0.0625rem solid #ccc;

&:last-child {
     text-align: right;
     font-weight: bold;
 }

&:first-child {
     font-weight: bold;
 }
}
}

.resultsHeader {
  font-weight: 700;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
}

.rotateimg180 {
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
}
.arrowIcon {
  margin: 8px;
}

